module.exports = __webpack_public_path__ + "98efe2cbfe5d2b673112f3a4986a95b8.png";